module.exports = __webpack_public_path__ + "static/media/Rubik-MediumItalic.5fd41096.ttf";